import { jsx as _jsx } from "react/jsx-runtime";
import { useRetrieveTransferRequest } from "../api/TransferRequestApiProvider";
import { useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { ManagerTransferRequestView } from "./ManagerTransferRequestView";
import { PlayerTransferRequestView } from "./PlayerTransferRequestView";
export const TransferRequest = () => {
    const { id } = useNumericParams();
    const { data: transferRequest, error, isLoading, } = useRetrieveTransferRequest({ id });
    const teamId = transferRequest?.team;
    const { data: team, error: teamError, isLoading: teamIsLoading, } = useRetrieveTeam({ id: teamId });
    const { data: permissions, error: permissionsError, isLoading: permissionsIsLoading, } = useRetrieveUserTeamPermissions({ teamId });
    if (isLoading || (!!teamId && (teamIsLoading || permissionsIsLoading))) {
        return _jsx(Loading, {});
    }
    if (error ||
        !transferRequest ||
        teamError ||
        !team ||
        permissionsError ||
        !permissions) {
        return _jsx(ErrorView, { error: error || teamError || permissionsError });
    }
    // Anyone who can modify the team (owner, manager, assistant managers) may
    // process the request — matching the backend's process permission.
    if (permissions.canModify) {
        return (_jsx(ManagerTransferRequestView, { transferRequest: transferRequest, team: team }));
    }
    return (_jsx(PlayerTransferRequestView, { transferRequest: transferRequest, team: team }));
};
